__turbopack_context__.v({
  "quiz": "quiz-module-scss-module__o6-KUW__quiz",
  "quiz-container": "quiz-module-scss-module__o6-KUW__quiz-container",
});
